<div class="image-container">
  <div class="image-wrapper" [style.transform]="'scale(' + scale + ')'">
    <ng-content select="[loader]" *ngIf="loading"></ng-content>
    <img loading="lazy" draggable="false" [src]="safeUrl" [class.loading]="loading" />
    <ng-content select="[svg-overlay]"></ng-content>
  </div>
  <ng-content select="[badge]"></ng-content>
</div>
